export default {"src":"/_next/static/media/play-store.5fd660e0.svg","height":65,"width":214,"blurWidth":0,"blurHeight":0};